import { render, staticRenderFns } from "./ViewBusinessBills.vue?vue&type=template&id=7596b714"
import script from "./ViewBusinessBills.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewBusinessBills.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports